import React, { useState } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import FactoryImage from '../factory.png';
import { BuildingsFill } from 'react-bootstrap-icons';
import { useAuth } from "../AuthProvider";
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import * as Yup from 'yup';

const TeamCard = ({ team }) => {
    return (
        <Card style={{ position: 'relative' }}>
            <div
                style={{
                    backgroundImage: `url(${FactoryImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 0,
                }}
            />
            <div
                style={{
                    backgroundColor: 'rgba(0, 80, 20, 0.9)',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1,
                }}
            />
            <Card.Body className="text-light d-flex justify-content-center align-items-center" style={{ position: 'relative', zIndex: 2 }}>
                <Card.Title className="d-flex align-items-center fs-4">
                    <BuildingsFill className="me-2" />
                    {team.name}
                </Card.Title>
            </Card.Body>
        </Card>
    );
};

const DeleteMemberButton = ({ onClick }) => {
    const { t } = useTranslation();
    return (
        <Button variant="warning" onClick={onClick}>
            {t('teams.delete-member')}
        </Button>
    );
};

const Members = ({ index, members, formik, setSaved, playersPerTeam }) => {
    const { t } = useTranslation();
    const handleMemberNameChange = (idx, e) => {
      setSaved(false);
      formik.setFieldValue(
        `teams[${index}].members[${idx}].name`,
        e.target.value
      );
    };
    const handleMemberEmailChange = (idx, e) => {
      setSaved(false);
      formik.setFieldValue(
        `teams[${index}].members[${idx}].email`,
        e.target.value
      );
    };
    const addMember = () => {
      setSaved(false);
      const newTeams = formik.values.teams.map((team, teamIndex) => {
        if (teamIndex !== index) return team;
        return {
          ...team,
          members: [
            ...(team.members || []),
            { name: '', email: '' }
          ]
        };
      });
      formik.setFieldValue('teams', newTeams);
    };
    const deleteMember = (idx) => {
        setSaved(false);
        const teams = [...formik.values.teams];
        teams[index].members.splice(idx, 1);
        formik.setFieldValue('teams', teams);
    };

    return (
        <Form.Group className="mb-3">
            <Table key={index} className="single-border-table">
                <tbody>
                    <tr>
                        <td>
                            {
                               members.map((member, i) => <Form.Group key={i} className="mb-3 d-flex align-items-center">
                                  <Form.Control
                                    type="text"
                                    id="name"
                                    placeholder={t('teams.member-name')}
                                    value={member.name || ''}
                                    onChange={(e) => handleMemberNameChange(i, e)}
                                    onBlur={() => formik.setFieldTouched(`teams[${index}].members[${i}]`)}
                                    isInvalid={formik.touched.teams && Array.isArray(formik.errors.teams) && !!formik.errors.teams?.[index]?.members?.[i]?.name}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors?.teams?.[index]?.members?.[i]?.name || ''}
                                  </Form.Control.Feedback>
                                  <Form.Control
                                    type="text"
                                    id="email"
                                    placeholder={t('teams.member-email')}
                                    value={member.email || ''}
                                    onChange={(e) => handleMemberEmailChange(i, e)}
                                    onBlur={() => formik.setFieldTouched(`teams[${index}].members[${i}]`)}
                                    isInvalid={formik.touched.teams && Array.isArray(formik.errors.teams) && !!formik.errors.teams?.[index]?.members?.[i]?.email}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors?.teams?.[index]?.members?.[i]?.email || ''}
                                  </Form.Control.Feedback>
                                  <DeleteMemberButton onClick={() => deleteMember(i)} />
                               </Form.Group>)
                            }
                            <Button variant="secondary" disabled={members.length >= playersPerTeam} onClick={addMember}>
                              {t('teams.add-member')}
                            </Button>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Form.Group>
    );
};

const TeamName = ({ index, formik, setSaved }) => {
    const { t } = useTranslation();
    const handleTeamNameChange = (e) => {
        setSaved(false);
        const name = e.target.value;
        const teams = [...formik.values.teams];
        teams[index].name = name;
        formik.setFieldValue('teams', teams);
    };

    return (
        <Form.Group className="mb-3">
            <Table key={index} className="single-border-table">
                <tbody>
                    <tr>
                        <td>
                            <Form.Control
                              type="text"
                              placeholder={t('teams.name')}
                              value={formik.values?.teams?.[index]?.name || ''}
                              onChange={(e) => handleTeamNameChange(e)}
                              onBlur={() => formik.setFieldTouched(`teams[${index}].name`)}
                              isInvalid={formik.touched.teams && Array.isArray(formik.errors.teams) && !!formik.errors.teams?.[index]?.name}
                            />
                            <Form.Control.Feedback type="invalid">
                              {formik.errors?.teams?.[index]?.name || ''}
                            </Form.Control.Feedback>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Form.Group>
    );
};

const validationSchema = (t) => Yup.object({
  teams: Yup.array().of(
    Yup.object({
      name: Yup.string().required(t('teams.validation.name-required')),
      members: Yup.array().of(
        Yup.object({
          name: Yup.string().required(t('teams.validation.member-name-required')),
          email: Yup.string()
            .email(t('add-user.validation.invalid-email'))
            .required(t('teams.validation.member-name-required'))
        })
      )
    })
  )
});

const PlayerGameSetup = ({ game, reloadGame }) => {
    const auth = useAuth();
    const { t } = useTranslation();
    const [updating, setUpdating] = useState(false);
    const [saved, setSaved] = useState(true);
    const [error, setError] = useState();
    const formik = useFormik({
      initialValues: {
        teams: game?.teams || [],
      },
      validationSchema: validationSchema(t),
      onSubmit: values => {
          const data = {
              teams: values.teams,
          };
         axios.put(`/api/games/${game.id}/teams`, data, {
               headers: {
                 Authorization: `Bearer ${auth.token}`,
                 'Content-Type': 'application/json'
               },
             })
           .then(response => {
               setSaved(true);
               setUpdating(false);
           })
           .catch(error => {
               console.log(error);
               setError(error);
           });
      },
    });

    if (error) return <p>{t('game.loading-error')}: {error.message}</p>;

    return <>
            <Form onSubmit={formik.handleSubmit}>
              {game.teams.length === 0 && <div>{t('teams.no-teams')}</div>}
              <Row className="g-3">
                {formik.values.teams.map((team, i) => (
                  <Col key={i} xs={8}>
                    <Card style={{ width: '100%' }} className="text-center">
                     <TeamCard team={team} />
                     <Card.Body>
                         <TeamName index={i} formik={formik} setSaved={setSaved} />
                         {team.automaton
                            ? <div className="mb-3 fw-bold">{t('teams.automaton')}</div>
                            : <Members index={i} members={team.members || []} formik={formik} setSaved={setSaved} playersPerTeam={game.playersPerTeam} />
                         }
                     </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              <Row className="g-3">
                  <div className="mt-4">
                      <Button type="submit" variant="primary" disabled={!(formik.isValid && formik.dirty) || updating || saved} className="me-2">{t('common.save')}</Button>
                  </div>
              </Row>
            </Form>
    </>;
};

export default PlayerGameSetup;
